var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartyBalloon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40009 8.61813C4.71668 9.24035 4.25 10.2059 4.25 11.6C4.25 13.0211 4.71163 14.4934 5.4624 15.5968C6.21856 16.7082 7.19376 17.35 8.2 17.35C9.19892 17.35 10.175 16.6917 10.9359 15.5619C11.6898 14.4424 12.15 12.9684 12.15 11.6C12.15 10.261 11.6865 9.29102 10.996 8.65207C10.2975 8.00571 9.31399 7.65 8.2 7.65C7.07553 7.65 6.09351 7.98682 5.40009 8.61813ZM4.5249 7.65686C5.50649 6.76318 6.82447 6.35 8.2 6.35C9.58601 6.35 10.9025 6.79429 11.879 7.69792C12.8635 8.60897 13.45 9.93898 13.45 11.6C13.45 13.2316 12.9102 14.9576 12.0141 16.2881C11.125 17.6083 9.80108 18.65 8.2 18.65C6.60623 18.65 5.28143 17.6418 4.3876 16.3282C3.48836 15.0065 2.95 13.2789 2.95 11.6C2.95 9.89409 3.53332 8.55965 4.5249 7.65686Z",
    fill: "#F37260"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 7.4C20.5 10.5 18.4 14 15.8 14C13.2 14 11.1 10.6 11.1 7.4C11.1 4.2 13.2 2.6 15.8 2.6C18.4 2.6 20.5 4.3 20.5 7.4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9205 4.27333C12.2215 4.93119 11.75 5.94897 11.75 7.4C11.75 8.86869 12.2353 10.3915 13.0125 11.5345C13.7975 12.6889 14.7986 13.35 15.8 13.35C16.7943 13.35 17.7962 12.6723 18.5858 11.4995C19.3662 10.3404 19.85 8.81609 19.85 7.4C19.85 6.00385 19.3814 4.98181 18.6759 4.30736C17.9648 3.62763 16.9593 3.25 15.8 3.25C14.6306 3.25 13.6266 3.60873 12.9205 4.27333ZM12.0295 3.32667C13.0234 2.39127 14.3694 1.95 15.8 1.95C17.2407 1.95 18.5852 2.42237 19.5741 3.36763C20.5686 4.31818 21.15 5.69615 21.15 7.4C21.15 9.08391 20.5838 10.8596 19.6642 12.2255C18.7538 13.5777 17.4057 14.65 15.8 14.65C14.2014 14.65 12.8525 13.6111 11.9375 12.2655C11.0147 10.9085 10.45 9.13131 10.45 7.4C10.45 5.65102 11.0285 4.2688 12.0295 3.32667Z",
    fill: "#1EA5B0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8 14.85C16.159 14.85 16.45 15.141 16.45 15.5V19C16.45 19.359 16.159 19.65 15.8 19.65C15.441 19.65 15.15 19.359 15.15 19V15.5C15.15 15.141 15.441 14.85 15.8 14.85Z",
    fill: "#F37260"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2 18.95C8.55899 18.95 8.85 19.241 8.85 19.6V22.4C8.85 22.759 8.55899 23.05 8.2 23.05C7.84102 23.05 7.55 22.759 7.55 22.4V19.6C7.55 19.241 7.84102 18.95 8.2 18.95Z",
    fill: "#1BA5B0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyBalloon);
export default __webpack_public_path__ + "static/media/party_balloon.ca273bc752158ce594ece68976f7c468.svg";
export { ForwardRef as ReactComponent };